import Repository from './Repository.js';

class ProductsRepository extends Repository {
    async getProductsSummary(query) {
        return await this.get('products/summary', query);
    }
}

export default new ProductsRepository();
